import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    API_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import { useParams } from "react-router";
import { useLocation } from 'react-router-dom';
import { handleApiCall } from "../../utilities/helper";

const SubDepartmentDetails = () => {
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [data, setData] = useState(null);
    const [controller, setController] = useState(null);
    const { id } = useParams();
    console.log("data", data)

    // useEffect(() => {
    //     if (data) {
    //         setLoading(false);
    //     }
    // }, [data]);


    const callListByIdApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/sub-department/${id}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListByIdApi();
    }, [id]);


    return (
        <>
            <PageMeta
                title={`SubDepartment Details - ${DEFAULT_PAGE_TITLE}`}
                description={`SubDepartment Details - ${DEFAULT_PAGE_DESCRIPTION}`}
            />

            <div className="flex justify-between items-center mb-4">
                <PageBreadcrumb
                    pageTitle="Subdepartment Details"
                    breadcrumbs={[
                        { label: "Subdepartment", path: "/sub-department" },
                        { label: "Subdepartment Details" }
                    ]}
                />
            </div>

            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md mx-auto h-full">
                    <div className="flex flex-col md:flex-row gap-8">
                        <div className="w-full md:w-1/3 space-y-6">
                            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm">
                                <h3 className="text-sm text-gray-500 dark:text-gray-400">SubDepartment Name</h3>
                                <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                    {data?.subDepartmentName}
                                </p>
                            </div>

                            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm">
                                <h3 className="text-sm text-gray-500 dark:text-gray-400">Department</h3>
                                <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                    {data?.department?.departmentName}
                                </p>
                            </div>

                            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm flex items-center gap-5">
                                <h3 className="text-sm text-gray-500 dark:text-gray-400">Status</h3>
                                <span
                                    className={`px-3 py-1 text-sm rounded-full font-medium ${data?.status === 1
                                            ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                                            : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
                                        }`}
                                >
                                    {data?.status === 1 ? "Active" : "Inactive"}
                                </span>
                            </div>
                        </div>

                        <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700">
                            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
                                Modules Assigned
                            </h2>

                            {data?.subDepartmentModules?.length > 0 ? (
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {data.subDepartmentModules.map((item) => (
                                        <div
                                            key={item.subDepartmentModuleId}
                                            className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm flex items-center justify-between"
                                        >
                                            <span className="text-sm font-medium text-gray-800 dark:text-gray-100">
                                                {item.module.moduleName}
                                            </span>
                                            {/* <span
                      className={`px-2 py-1 text-xs rounded-full ${
                        item.statusId === 1
                          ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                          : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
                      }`}
                    >
                      {item.statusId === 1 ? "Active" : "Inactive"}
                    </span> */}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p className="text-sm text-gray-500 dark:text-gray-400">
                                    No modules assigned.
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
export default SubDepartmentDetails;